import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const menuItems = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About Me',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Certificates',
    href: '#certificates'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-white shadow-md" data-id="element-115">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex justify-between h-16" data-id="element-117">
          <div className="flex items-center" data-id="element-118">
            <span className="text-xl font-bold text-blue-600" data-id="element-119">
              Adeyeye Afeez
            </span>
          </div>
          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-120">
            {menuItems.map((item, index) => <a key={index} href={item.href} className="text-gray-700 hover:text-blue-600 font-medium transition-colors" data-id="element-121">
                {item.name}
              </a>)}
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-122">
            <button onClick={toggleMenu} className="text-gray-700 hover:text-blue-600 focus:outline-none" data-id="element-123">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-124" /> : <MenuIcon className="h-6 w-6" data-id="element-125" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-126">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-127">
            {menuItems.map((item, index) => <a key={index} href={item.href} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50" onClick={toggleMenu} data-id="element-128">
                {item.name}
              </a>)}
          </div>
        </div>}
    </nav>;
}